module.exports = __webpack_public_path__ + "assets/img/c1b9-hk.svg";